// extracted by mini-css-extract-plugin
module.exports = {"ownerInfoMargin":"OwnerHome_ownerInfoMargin__1DaSn"};